__turbopack_context__.v({
  "breadcrumbs": "styles-module-scss-module__lbZiTa__breadcrumbs",
  "breadcrumbs__current": "styles-module-scss-module__lbZiTa__breadcrumbs__current",
  "breadcrumbs__link": "styles-module-scss-module__lbZiTa__breadcrumbs__link",
  "breadcrumbs__separator": "styles-module-scss-module__lbZiTa__breadcrumbs__separator",
  "scroll": "styles-module-scss-module__lbZiTa__scroll",
});
